var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66648 1.81393C7.25182 1.2277 8.20121 1.22734 8.78699 1.81313L10.0329 3.05905C10.6137 3.63984 10.6197 4.58008 10.0464 5.16828L5.42988 9.90491C5.0536 10.291 4.53751 10.5087 3.99862 10.5086L2.62254 10.5086C1.91185 10.5086 1.34429 9.91612 1.37418 9.20552L1.43325 7.80101C1.45432 7.30019 1.66247 6.82552 2.01651 6.47094L6.66648 1.81393ZM8.08042 2.52077C7.88516 2.32551 7.5687 2.32563 7.37358 2.52104L6.63049 3.26526L8.59253 5.2273L9.33086 4.46977C9.52196 4.2737 9.51995 3.96029 9.32635 3.7667L8.08042 2.52077ZM2.72362 7.17805L5.92391 3.9729L7.8945 5.94349L4.71429 9.2064C4.52615 9.39943 4.26811 9.50828 3.99866 9.50827L2.62259 9.50821C2.48045 9.5082 2.36693 9.38972 2.37291 9.2476L2.43199 7.84308C2.44252 7.59267 2.5466 7.35534 2.72362 7.17805ZM10.2569 10.4725C10.5329 10.4725 10.7567 10.2485 10.7567 9.97229C10.7567 9.69605 10.5329 9.4721 10.2569 9.4721H7.19602C6.91998 9.4721 6.69621 9.69605 6.69621 9.97229C6.69621 10.2485 6.91998 10.4725 7.19602 10.4725H10.2569Z",
    fill: "#A4A1B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.80940e0d805d27db86b2533c4073e4af.svg";
export { ForwardRef as ReactComponent };